import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { PiEye, PiEyeSlash, PiChatCircleDotsBold } from "react-icons/pi";
import { UI_Header, UI_HeaderLeft, UI_HeaderRight, UI_HeaderRight_item } from "../PanelStyle";
import { FaXmark } from "react-icons/fa6";
import { allowAddCommentOnMapAtom, showCommentOnMapAtom } from "~/components/Map/Comment/CommentStore";
import { useAtom } from 'jotai';
import { showCommentPanelAtom } from "../../stores/mapStore";
import CommentItem from "./CommentItem/CommentItem";
import { IoEllipsisHorizontal } from "react-icons/io5";
import { Comment_AddComment_RequestBody, Comment_GetPage_RequestQuery, CommentAPIs } from "~/common/typescript/apis/CommentAPIs";
import { currentProjectAtom } from "~/stores/ProjectStore";
import mouse_plus from "~/assets/svg/mouse_plus.svg";
import { Project_Base } from "~/common/typescript/models/Project";
import { Empty, Tooltip } from "antd";
import { CommentMapUtilOptimized } from "../../Comment/CommentMapUtilOptimized";
import maplibregl from "maplibre-gl";
import { CommentItemUtil } from "./CommentItem/CommentItemUtil";
import { Comment_Base } from "~/common/typescript/models/Comment";
import { commentsAtom } from "~/components/Map/Comment/CommentStore";
import { isMapLoadedDoneAtom } from "../../stores/mapStore";
import { TbMapPlus } from "react-icons/tb";


let _showCommentPanel = false;
let _showCommentOnMap = false;
let _currentProject: Project_Base;
const CommentPanel = () => {
  const [allowAddCommentOnMap, setAllowAddCommentOnMap] = useAtom(allowAddCommentOnMapAtom);
  const [showCommentOnMap, setshowCommentOnMap] = useAtom(showCommentOnMapAtom);
  const [showCommentPanel, setShowCommentPanel] = useAtom<boolean>(showCommentPanelAtom);
  const [currentProject, setCurrentProject] = useAtom(currentProjectAtom);
  const [comments, setComments] = useAtom(commentsAtom);
  const [isMapLoadedDone, setMapLoadedDone] = useAtom(isMapLoadedDoneAtom);

  const [filteredComments, setFilteredComments] = useState<Comment_Base[]>([]);

  useEffect(() => {
    setFilteredComments(comments.filter((comment) => !comment.is_deleted));
  }, [comments]);

  useEffect(() => {
    _showCommentPanel = showCommentPanel;
  }, [showCommentPanel]);

  useEffect(() => {
    _showCommentOnMap = showCommentOnMap;
  }, [showCommentOnMap]);

  useEffect(() => {
    _currentProject = currentProject;
  }, [currentProject]);

  const onClick = async (e: any) => {
    if (!_showCommentPanel) return;
    if (!_showCommentOnMap) return;
    if (!isMapLoadedDone) return;
    if (!window.map) return;
    console.log('e', e);

    const features = window.map.queryRenderedFeatures(e.point, {
      layers: [CommentMapUtilOptimized._layerId] // Specify the ID of the layer you want to check
    });

    if (features && features.length > 0) {
      return;
    } else {
      if (!allowAddCommentOnMap) return;
      const lngLat = e.lngLat;
      // Tạo comment
      {
        const payload: Comment_AddComment_RequestBody = {
          projectId: _currentProject?.id as number,
          title: "Chưa điền tiêu đề",
          description: "Chưa điền mô tả",
          geojson: JSON.stringify({
            type: "point",
            coordinates: [lngLat.lng, lngLat.lat]
          })
        }
        const result = await CommentAPIs.remote_addComment(payload);

        CommentMapUtilOptimized.hashPopupByCommentId.set(result.data!.id!, new maplibregl.Popup());
        setComments([...comments, result.data!]);
      }
    }
  };
  const onMouseEnter = async (e: any) => {
    if (!_showCommentPanel) return;
    if (!_showCommentOnMap) return;
    if (!isMapLoadedDone) return;
    if (!allowAddCommentOnMap) return;
    if (window.map) {
      window.map.getCanvas().style.cursor = `url('${mouse_plus}') 0 0, pointer`;
    }
  }
  const onMouseLeave = async (e: any) => {
    if (!isMapLoadedDone) return;
    if (window.map) {
      window.map.getCanvas().style.cursor = 'pointer';
    }
  }

  useEffect(() => {
    if (window.map) {
      const map = window.map;
      map.on('click', onClick);
      map.getCanvas().addEventListener('mouseenter', onMouseEnter);
      map.getCanvas().addEventListener('mouseleave', onMouseLeave);
    }
    return () => {
      if (window.map) {
        window.map.off('click', onClick);
        window.map.getCanvas().removeEventListener('mouseenter', onMouseEnter);
        window.map.getCanvas().removeEventListener('mouseleave', onMouseLeave);
      }
    }
  }, [isMapLoadedDone, comments, allowAddCommentOnMap]);

  return (
    <UI_Wrapper>
      <UI_Header>
        <UI_HeaderLeft style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <PiChatCircleDotsBold style={{ color: '#2563eb', fontSize: '18px' }} />
          <span>Ghi chú</span>
        </UI_HeaderLeft>
        <UI_HeaderRight>
          {/* Button allow edit on map */}
          <Tooltip title="Cho phép thêm ghi chú trên bản đồ">
            <UI_HeaderRight_item className={allowAddCommentOnMap ? 'active' : ''} onClick={() => setAllowAddCommentOnMap(!allowAddCommentOnMap)}>
              <TbMapPlus />
            </UI_HeaderRight_item>
          </Tooltip>
          {/* End Button allow edit on map */}
          {/* Button toggle comment on map */}
          <Tooltip title="Hiển thị/Ẩn ghi chú trên bản đồ">
            <UI_HeaderRight_item onClick={() => setshowCommentOnMap(!showCommentOnMap)}>
              {showCommentOnMap ? <PiEye /> : <PiEyeSlash />}
            </UI_HeaderRight_item>
          </Tooltip>
          {/* End Button toggle comment on map */}
          {/* Button more */}
          <Tooltip title="Công cụ khác">
            <UI_HeaderRight_item>
              <IoEllipsisHorizontal />
            </UI_HeaderRight_item>
          </Tooltip>
          {/* End Button more */}
          {/* Button close */}
          <Tooltip title="Đóng bảng ds ghi chú">
            <UI_HeaderRight_item onClick={() => {
              setShowCommentPanel(false);
            }}>
              <FaXmark />
            </UI_HeaderRight_item>
          </Tooltip>
          {/* End Button close */}
        </UI_HeaderRight>
      </UI_Header>
      <UI_List>
        {filteredComments.map((comment) => (
          <UI_Item_Wrapper key={comment.id} onDoubleClick={() => {
            CommentMapUtilOptimized.hashPopupByCommentId.set(comment.id!, new maplibregl.Popup());
            setComments([...comments]);
            CommentItemUtil.zoomToComment(comment);
          }}>
            <CommentItem comment={comment} />
          </UI_Item_Wrapper>
        ))}
        {
          filteredComments.length === 0 && <div style={{ padding: 8, color: '#aaa' }}>
            <Empty />
          </div>
        }
      </UI_List>
    </UI_Wrapper>
  );
}

export default memo(CommentPanel);

const UI_Wrapper = styled.div`
  width: 300px;
  height: 500px;
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: white;
  border-radius: 8px;
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
`;


const UI_List = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
  overflow-y: auto;
`;

const UI_Item_Wrapper = styled.div`
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid #e0e0e0;
  &:hover {
    background-color: #e0e0e0;
  }
`;